import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import AlertService from "@/core/services/alert.service";
import router from '@/router'
import Vue from "vue";

// action types

export const PAGINATE_ALL_PASSOLIGS = "getPaginatedPassoligs";
export const PAGINATE_ALL_MY_PASSOLIGS = "getPaginatedMyPassoligs";
export const ALL_PASSOLIGS = "getAllPassoligs";
export const ALL_MY_PASSOLIGS = "getAllMyPassoligs";
export const ALL_MY_FRIENDS_PASSOLIGS = "getAllMyFriendsPassoligs";
export const CREATE_PASSOLIG_FORM = "createPassoligForm";
export const DELETE_PASSOLIG = "deletePassolig";
export const GET_PASSOLIG_DATA = "getPassoligData";
export const CREATE_PASSOLIG = "createPassolig";
export const UPDATE_PASSOLIG = "updatePassolig";
export const APPROVE_PASSOLIG = "approvePassolig";
export const DENY_PASSOLIG = "denyPassolig";
export const SEND_BACK_PASSOLIG = "sendBackPassolig";
export const SEND_AGAIN_PASSOLIG = "sendAgainPassolig";
export const UPDATE_PASSOLIG_EXPIRATION_DATE = "updatePassoligExpirationDate";
export const GET_PASSOLIG_HISTORY = "getPassoligHistory";


// mutation types

export const SET_PAGINATED_PASSOLIGS = "setPaginatedPassoligs";
export const SET_PAGINATED_MY_PASSOLIGS = "setPaginatedMyPassoligs";

export const SET_ALL_PASSOLIGS = "setAllPassoligs";
export const SET_PASSOLIG_DATA = "setPassoligData";
export const SET_PASSOLIG_META = "setPassoligMeta";
export const SET_PASSOLIG_ERROR = "setPassoligError";
export const SET_PASSOLIG_LOADING = "setPassoligLoading";
export const CLEAR_PASSOLIG_ERROR = "clearPassoligError";
export const SET_IS_DISABLED_PASSOLIG = "setIsDisabledPassolig";


const state = {
    passoligs: [],
    paginatedPassoligs: [],
    paginatedMyPassoligs: [],
    passolig_data: {},
    meta_passolig : {
        totalPages: 0,
        total: 0,
        from: 0,
        to: 0,
    },
    errors: [],
    loading: false,
    isDisabled: false
    };

const getters = {
   
    paginateAllPassoligs(state) {
        return state.paginatedPassoligs;
    },

    paginateAllMyPassoligs(state) {
        return state.paginatedMyPassoligs;
    },

    allPassoligs(state) {
        return state.passoligs;
    },

    getPassoligData(state) {
        return state.passolig_data;
    },

    meta_passolig(state) {
        return state.meta_passolig;
    },
    
};

const actions = {
 
    [PAGINATE_ALL_PASSOLIGS](context, payload) {
        context.commit(SET_IS_DISABLED_PASSOLIG, false);
        context.commit(SET_PASSOLIG_LOADING, true);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.get(`/passoligs?size=${payload.itemsPerPage}&page=${payload.pageNumber}&sortBy=${payload.sortBy}&sortDesc=${payload.sortDesc}&searchText=${payload.search}&check=${payload.x}`)
        .then(({ data }) => {
            
            if(data == 403) {
                context.commit(SET_PASSOLIG_LOADING, false);
                router.push('nopermission');
            }
            else {
                context.commit(SET_PAGINATED_PASSOLIGS, data);
                context.commit(SET_PASSOLIG_META, data);
                context.commit(SET_PASSOLIG_LOADING, false);
            }
            
        })
        .catch(( response ) => {
            context.commit(SET_PASSOLIG_LOADING, false);
            context.commit(SET_PASSOLIG_ERROR, response.errors);
        });
        ;
        
    },

    [PAGINATE_ALL_MY_PASSOLIGS](context, payload) {
        context.commit(SET_IS_DISABLED_PASSOLIG, false);
        context.commit(SET_PASSOLIG_LOADING, true);
        JwtService.getToken();
        ApiService.setHeader();
        Vue.axios.get(`/my_passoligs?size=${payload.itemsPerPage}&page=${payload.pageNumber}&sortBy=${payload.sortBy}&sortDesc=${payload.sortDesc}&searchText=${payload.search}&check=${payload.x}`)
        .then(({ data }) => {
            
            if(data == 403) {
                context.commit(SET_PASSOLIG_LOADING, false);
                router.push('nopermission');
            }
            else {
                context.commit(SET_PAGINATED_MY_PASSOLIGS, data);
                context.commit(SET_PASSOLIG_META, data);
                context.commit(SET_PASSOLIG_LOADING, false);
            }
            
        })
        .catch((error) => {
            if (error.response) {
                if (error.response.status === 402) {
                    context.commit(SET_PASSOLIG_LOADING, false);
                    if(error.response.data.error === 'Insufficient balance') {
                        router.push({ name: 'credit_balance' });
                    }

                    if(error.response.data.error === 'Member status error') {
                        router.push({ name: 'status_error' });
                    }

                    if(error.response.data.error === 'No photo found') {
                        router.push({ name: 'no_photo' });
                    }
                } else {
                    context.commit(SET_PASSOLIG_LOADING, false);
                    context.commit(SET_PASSOLIG_ERROR, error.response.data.errors);
                }
            } else {
                // Handle cases where error.response is undefined (network error, etc.)
                context.commit(SET_PASSOLIG_LOADING, false);
            }
        });
        ;
        
    },

    [ALL_PASSOLIGS]() {
        return new Promise(resolve => {
            ApiService.get('/passoligsAll')
            .then((response) => {
                resolve(response);
            })
        });
    },

    [ALL_MY_PASSOLIGS]() {
        return new Promise(resolve => {
            ApiService.get('/passoligsMyAll')
            .then((response) => {
                resolve(response);
            })
        });
    },

    [ALL_MY_FRIENDS_PASSOLIGS](context, payload) {
        context.commit(SET_PASSOLIG_LOADING, true);
        JwtService.getToken();
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get(`/my_friends_passoligs?member_no=${payload.member_no}&check=${payload.x}`)
            .then((response) => {
                resolve(response);
                context.commit(SET_PASSOLIG_LOADING, false);
            })
        });
    },

    [CREATE_PASSOLIG_FORM](context) {
        context.commit(SET_PASSOLIG_LOADING, false);
        context.commit(SET_PASSOLIG_ERROR, false);
        context.commit(SET_IS_DISABLED_PASSOLIG, false);
    },

    [GET_PASSOLIG_DATA](context, payload) {
        context.commit(SET_IS_DISABLED_PASSOLIG, true);
        context.commit(SET_PASSOLIG_LOADING, true);
        context.commit(CLEAR_PASSOLIG_ERROR);
        return new Promise(resolve => {
            ApiService.get(`/passolig/${payload.id}`)
            .then(( response ) => {
                if(response.data == 403) {
                    context.commit(SET_PASSOLIG_LOADING, false);
                    router.push('/nopermission');
                }
                else {
                    context.commit(SET_PASSOLIG_DATA, response.data);
                    context.commit(SET_PASSOLIG_LOADING, false);
                    context.commit(SET_IS_DISABLED_PASSOLIG, false);
                    resolve(response);
                }
            })
            .catch(({ response }) => {
                context.commit(SET_PASSOLIG_LOADING, false);
                context.commit(SET_PASSOLIG_ERROR, response.data.errors);
                context.commit(SET_IS_DISABLED_PASSOLIG, true);
            });
        });
    },

    [CREATE_PASSOLIG](context, payload) {
        context.commit(SET_PASSOLIG_LOADING, false);
        context.commit(SET_IS_DISABLED_PASSOLIG, true);
        context.commit(CLEAR_PASSOLIG_ERROR);
        return ApiService.post("/passolig/store", payload.data)
        .then(( response ) => {
            if(response.data == 403) {
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde ekleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                context.commit(CLEAR_PASSOLIG_ERROR);
            }
            else{
                context.commit(SET_PASSOLIG_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Kayıt Başarılı",
                    "Passolig başarıyla kaydedilmiştir. Başka bir yakınınız için de passolig ekleyebilirsiniz.",
                    1000000
                );
                context.commit(CLEAR_PASSOLIG_ERROR);
                context.commit(SET_IS_DISABLED_PASSOLIG, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                return response;
            }
        })
        .catch(({ response }) => {
            context.commit(SET_PASSOLIG_LOADING, false);
            context.commit(SET_PASSOLIG_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_PASSOLIG, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
        });
    },

    [UPDATE_PASSOLIG](context, payload) {
        context.commit(SET_PASSOLIG_LOADING, true);
        context.commit(SET_IS_DISABLED_PASSOLIG, true);
        context.commit(CLEAR_PASSOLIG_ERROR);
        
        return ApiService.put(`/passolig/${payload.data.id}`, payload.data)
        .then((response) => {
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                context.commit(SET_PASSOLIG_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Güncelleme Başarılı",
                    payload.data.id + " ID numaralı passolig başarıyla güncellenmiştir."
                );
            
                context.commit(SET_IS_DISABLED_PASSOLIG, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_PASSOLIG_LOADING, false);
            context.commit(SET_PASSOLIG_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_PASSOLIG, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
            
        });
        
    },

    [UPDATE_PASSOLIG_EXPIRATION_DATE](context, payload) {
        context.commit(SET_PASSOLIG_LOADING, true);
        context.commit(SET_IS_DISABLED_PASSOLIG, true);
        context.commit(CLEAR_PASSOLIG_ERROR);

        return ApiService.put(`/passolig/expiration_date/${payload.data.id}`, {
            expiration_date: payload.data.expiration_date,
        })
        .then((response) => {

            context.commit(SET_PASSOLIG_LOADING, false);
            context.commit(SET_IS_DISABLED_PASSOLIG, false);

            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Passolig geçerlilik süresini güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                return response;
            }

            AlertService.makeToast(
                "success",
                "Güncelleme Başarılı",
                "Passolig geçerlilik süresi başarıyla güncellenmiştir."
            );

            if(payload.goBack){
                router.go(-1);
            }

            return response;
        })
        .catch(({ response }) => {
            context.commit(SET_PASSOLIG_LOADING, false);
            context.commit(SET_IS_DISABLED_PASSOLIG, false);

            // 422 doğrulama hatası alan altında gösterilir; diğer durumlarda
            // (ör. onaylanmamış kayıt) sunucunun mesajı toast ile verilir.
            if(response && response.data && response.data.errors){
                context.commit(SET_PASSOLIG_ERROR, response.data.errors);
                AlertService.makeToast(
                    "danger",
                    "Hata!",
                    "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
                );
            }
            else{
                AlertService.makeToast(
                    "danger",
                    "Hata!",
                    (response && response.data && response.data.message)
                        ? response.data.message
                        : "Passolig geçerlilik süresi güncellenemedi."
                );
            }
        });
    },

    [DELETE_PASSOLIG](context, payload) {
        context.commit(SET_PASSOLIG_LOADING, true);
        context.commit(CLEAR_PASSOLIG_ERROR);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.delete(`/passolig/${payload.itemToDelete}`)
        .then(( response ) => {
            context.commit(SET_PASSOLIG_LOADING, false);
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde silme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else {
                
                AlertService.makeToast(
                    "success",
                    "Silme Başarılı",
                    payload.itemToDelete + " ID numaralı passolig başarıyla silinmiştir."
                );
                
                
            }
        })
        .catch(( error ) => {
            context.commit(SET_PASSOLIG_ERROR, error);
            AlertService.makeToast(
                "warning",
                "Hata!",
                error
            );
        });
        
    },

    [APPROVE_PASSOLIG](context, payload) {
        context.commit(SET_PASSOLIG_LOADING, true);
        context.commit(SET_IS_DISABLED_PASSOLIG, true);
        context.commit(CLEAR_PASSOLIG_ERROR);
        
        return ApiService.put(`/passolig/approve/${payload.data.id}`, payload.data)
        .then((response) => {
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde onaylama yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                context.commit(SET_PASSOLIG_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Güncelleme Başarılı",
                    payload.data.id + " ID numaralı passolig onaylanmıştır."
                );
            
                context.commit(SET_IS_DISABLED_PASSOLIG, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_PASSOLIG_LOADING, false);
            context.commit(SET_PASSOLIG_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_PASSOLIG, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
            
        });
        
    },

    [DENY_PASSOLIG](context, payload) {
        context.commit(SET_PASSOLIG_LOADING, true);
        context.commit(SET_IS_DISABLED_PASSOLIG, true);
        context.commit(CLEAR_PASSOLIG_ERROR);
        
        return ApiService.put(`/passolig/deny/${payload.data.id}`, payload.data)
        .then((response) => {
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde onaylama yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                context.commit(SET_PASSOLIG_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Güncelleme Başarılı",
                    payload.data.id + " ID numaralı passolig onaylanmıştır."
                );
            
                context.commit(SET_IS_DISABLED_PASSOLIG, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_PASSOLIG_LOADING, false);
            context.commit(SET_PASSOLIG_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_PASSOLIG, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
            
        });
        
    },

    [SEND_BACK_PASSOLIG](context, payload) {
        context.commit(SET_PASSOLIG_LOADING, true);
        context.commit(SET_IS_DISABLED_PASSOLIG, true);
        context.commit(CLEAR_PASSOLIG_ERROR);
        
        return ApiService.put(`/passolig/send_back/${payload.data.id}`, payload.data)
        .then((response) => {
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde onaylama yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                context.commit(SET_PASSOLIG_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "İşlem Başarılı",
                    payload.data.id + " ID numaralı passolig geri gönderilmiştir."
                );
            
                context.commit(SET_IS_DISABLED_PASSOLIG, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_PASSOLIG_LOADING, false);
            context.commit(SET_PASSOLIG_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_PASSOLIG, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
            
        });
        
    },

    [SEND_AGAIN_PASSOLIG](context, payload) {
        context.commit(SET_PASSOLIG_LOADING, true);
        context.commit(SET_IS_DISABLED_PASSOLIG, true);
        context.commit(CLEAR_PASSOLIG_ERROR);
        
        return ApiService.put(`/passolig/send_again/${payload.data.id}`, payload.data)
        .then((response) => {
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde onaylama yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                context.commit(SET_PASSOLIG_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "İşlem Başarılı",
                    payload.data.id + " ID numaralı passolig onay için tekrar yöneticiye gönderilmiştir."
                );
            
                context.commit(SET_IS_DISABLED_PASSOLIG, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_PASSOLIG_LOADING, false);
            context.commit(SET_PASSOLIG_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_PASSOLIG, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
            
        });
        
    },

    [GET_PASSOLIG_HISTORY](context, payload) {
        context.commit(SET_IS_DISABLED_PASSOLIG, true);
        context.commit(SET_PASSOLIG_LOADING, true);
        context.commit(CLEAR_PASSOLIG_ERROR);
        return new Promise(resolve => {
            ApiService.get(`/passolig/history/${payload.id}`)
            .then(( response ) => {
                if(response.data == 403) {
                    context.commit(SET_PASSOLIG_LOADING, false);
                    router.push('/nopermission');
                }
                else {
                    context.commit(SET_PASSOLIG_DATA, response.data);
                    context.commit(SET_PASSOLIG_LOADING, false);
                    context.commit(SET_IS_DISABLED_PASSOLIG, false);
                    resolve(response);
                }
            })
            .catch(({ response }) => {
                context.commit(SET_PASSOLIG_LOADING, false);
                context.commit(SET_PASSOLIG_ERROR, response.data.errors);
                context.commit(SET_IS_DISABLED_PASSOLIG, true);
            });
        });
    },

    
    
};

const mutations = {

    [SET_PAGINATED_PASSOLIGS](state, paginatedPassoligs) {
        state.paginatedPassoligs = paginatedPassoligs.data;
    },

    [SET_PAGINATED_MY_PASSOLIGS](state, paginatedMyPassoligs) {
        state.paginatedMyPassoligs = paginatedMyPassoligs.data;
    },

    [SET_ALL_PASSOLIGS](state, passoligs) {
        state.passoligs = passoligs;
    },

    [SET_PASSOLIG_DATA](state, passoligs_data) {
        state.passoligs_data = passoligs_data;
        state.errors = [];
    },

    [SET_PASSOLIG_META](state, meta_passolig) {
        state.meta_passolig = meta_passolig;
    },

    [SET_PASSOLIG_ERROR](state, error) {
        state.errors = error;
    },

    [CLEAR_PASSOLIG_ERROR](state) {
        state.errors = [];
    },
    
    [SET_PASSOLIG_LOADING](state, loading) {
        state.loading = loading;
    },

    [SET_IS_DISABLED_PASSOLIG](state, isDisabled) {
        state.isDisabled = isDisabled;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};
